import { connectSearchBox } from 'instantsearch.js/es/connectors'

// Create a render function
const renderSearchBox = (renderOptions, isFirstRender) => {
    const { query, refine, widgetParams } = renderOptions;

    if (isFirstRender) {

        widgetParams.container.innerHTML = `
        <form class="barreRecherche" action="#" method="post">
            <div class="form-group">
                <input type="text" class="form-control form-control-lg" placeholder="Rechercher ...">
            </div>
        </form>
        `;
        
        const input = widgetParams.container.querySelector('input');

        input.addEventListener('input', event => {
            refine(event.target.value);
        });

    }

    widgetParams.container.querySelector('input').value = query;
};

const customSearchBox = connectSearchBox(renderSearchBox);

export default customSearchBox;